import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { urlEncodeObject } from "client_legacy/ndaw/urlHelper";

export type AppointmentRoomModel = {
	id: string;
	displayName: string;
};

export function getAppointmentRooms(
	searchTerm: string,
	maxNumberOfItems?: number,
	signal?: AbortSignal
): Promise<readonly AppointmentRoomModel[]> {
	return httpClient.get<readonly AppointmentRoomModel[]>(
		`UiApi/Email/Rooms?${urlEncodeObject({ searchTerm, maxNumberOfItems }, true)}`,
		undefined,
		{ signal }
	);
}
